export class TrimsInfo{
    trimsId: number;
    trimName: string;

    constructor(trimsId: number,trimName: string ) {
        this.trimsId=trimsId;
        this.trimName=trimName;
    }
}